import React, { useRef, useEffect } from 'react';
import { motion, useInView, useScroll, useTransform } from 'framer-motion';

// Import company logos...
import logo1 from "../assets/images/Acer.jpg";
import logo2 from "../assets/images/Micromax-logo.png";
import logo3 from "../assets/images/unnamed-1.jpg";
import logo4 from "../assets/images/Play (1) - Copy.jpg";
import logo5 from "../assets/images/omni-remotes.jpeg";
import logo6 from "../assets/images/Wings.jpg";
import logo7 from "../assets/images/ITEL.jpg";
import logo8 from "../assets/images/TCL.png";
import logo9 from "../assets/images/Lumiford.jpeg";
import logo10 from "../assets/images/Compaq.jpg";
import logo11 from "../assets/images/oppo.jpeg";
import logo12 from "../assets/images/vivo.jpeg";
import logo13 from "../assets/images/miphi_main_logo.png";
import logo15 from "../assets/images/Phison.png";

const Partners = () => {
  const containerRef = useRef(null);
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"]
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, -150]);
  const opacity = useTransform(scrollYProgress, [0, 0.2], [1, 0]);
  const scale = useTransform(scrollYProgress, [0, 0.2], [1, 0.95]);
  const companies = [
    { id: 1, name: "Acer", logo: logo1, category: "Computing" },
    { id: 2, name: "Micromax", logo: logo2, category: "Mobile & Electronics" },
    { id: 3, name: "Unnamed", logo: logo3, category: "Technology" },
    { id: 4, name: "Play", logo: logo4, category: "Entertainment" },
    { id: 5, name: "Omni Remotes", logo: logo5, category: "Accessories" },
    { id: 6, name: "Wings", logo: logo6, category: "Audio" },
    { id: 7, name: "ITEL", logo: logo7, category: "Mobile" },
    { id: 8, name: "TCL", logo: logo8, category: "Electronics" },
    { id: 9, name: "Lumiford", logo: logo9, category: "Audio" },
    { id: 10, name: "Compaq", logo: logo10, category: "Computing" },
    { id: 11, name: "Oppo", logo: logo11, category: "Mobile" },
    { id: 12, name: "Vivo", logo: logo12, category: "Mobile" },
    { id: 13, name: "Miphi", logo: logo13, category: "Technology" },
    { id: 15, name: "Phison", logo: logo15, category: "Storage" }
  ];
 


  return (
    <div className="relative bg-white">
      {/* Hero Section with Parallax and Scroll Effects */}
      <div className="relative h-[80vh] lg:h-[70vh] flex items-center justify-center overflow-hidden">
  <motion.div 
    style={{ y, opacity, scale }}
    className="absolute inset-0 pointer-events-none"
  >
    <div className="absolute inset-0 bg-gradient-to-b from-orange-50/50 to-white/80" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,165,0,0.1),transparent_70%)]" />
  </motion.div>

  <div ref={headerRef} className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 lg:py-16">
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={isHeaderInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 1, ease: "easeOut" }}
      className="text-center"
    >
      <motion.div
        animate={{ scale: [1, 1.02, 1] }}
        transition={{ duration: 3, repeat: Infinity }}
        className="mb-8"
      >
        <h1 className="text-5xl md:text-7xl lg:text-6xl font-bold mb-6">
          Our Trusted
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-yellow-500">
            {" "}Partners
          </span>
        </h1>
        <motion.div 
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{ duration: 1.5, delay: 0.5 }}
          className="h-1 bg-gradient-to-r from-orange-500 to-yellow-400 mx-auto rounded-full mb-6"
        />
      </motion.div>
      
      <p className="text-xl md:text-2xl lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
        Building tomorrow's technology with today's innovation through strategic partnerships
      </p>
    </motion.div>
  </div>
</div>


<div className="relative py-20 bg-white">
  <div className="max-w-7xl mx-auto px-4">
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
      {companies.map((company) => (
        <motion.div
          key={company.id}
          whileHover={{ scale: 1.05 }}
          className="bg-white p-4 rounded-xl border hover:shadow-lg transition-all duration-300
                    border border-orange-100"
        >
          <div className="aspect-square relative overflow-hidden rounded-lg">
            <img
              src={company.logo}
              alt={`${company.name} logo`}
              className="w-full h-full object-contain p-2"
            />
          </div>
          <div className="mt-2 text-center">
            <h3 className="font-medium text-gray-900">{company.name}</h3>
            <p className="text-xs text-orange-600">{company.category}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </div>
</div>


      {/* CTA Section */}
      {/* <motion.section 
        className="relative py-24 bg-gradient-to-b from-white to-orange-50"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-7xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h2 className="text-4xl font-bold mb-6 text-gray-900">
              Ready to Join Our Innovation Journey?
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Partner with us to create exceptional products and shape the future of technology.
            </p>
            <motion.a
              href="#contact"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center px-8 py-4 rounded-full 
                         bg-gradient-to-r from-orange-600 to-yellow-500 
                         text-white font-semibold shadow-lg hover:shadow-xl 
                         transition-all duration-300"
            >
              Become a Partner
              <motion.svg
                className="ml-2 w-5 h-5"
                animate={{ x: [0, 5, 0] }}
                transition={{ duration: 1.5, repeat: Infinity }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </motion.svg>
            </motion.a>
          </motion.div>
        </div>
      </motion.section> */}
    </div>
  );
};

export default Partners;